import { FC } from "react";

const ImageMinimize: FC = () => {
  return <div>
    图片压缩
  </div>;
};

export default ImageMinimize;
